export const LogoMark = ({ className = "h-11 w-auto", dark = false }) => (
  <img
    src="/logo-crest.png"
    alt="Estate Paradise crest"
    className={`${className} ${dark ? "rounded-sm bg-[#F5F3ED] p-1" : ""}`}
  />
);

export const Logo = ({ dark = false, compact = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark className={compact ? "h-9 w-auto" : "h-11 w-auto"} dark={dark} />
    <div className="leading-none">
      <p className={`font-serif font-semibold tracking-wide ${compact ? "text-base" : "text-lg"} ${dark ? "text-white" : "text-navy-900"}`}>
        ESTATE <span className="text-gold-500">PARADISE</span>
      </p>
      <p className={`mt-1 text-[9px] font-semibold uppercase tracking-[0.32em] ${dark ? "text-gold-300" : "text-gold-600"}`}>
        Real Estate Brokers
      </p>
    </div>
  </div>
);
